
<template>
  <!-- 使用说明：表格宽高为父容器的100%，标签名称 el-pagetable，需要传入的属性部分说明： -->
  <!-- 需传入url，若不使用封装的axios中baseUrl则use-base-url传入false -->
  <!-- axios默认调取接口方法为get， -->
  <!-- 查询参数传入params中，传入后参数对象会默认加入分页参数pageSize，pageIndex，后台按以上名字接收 -->
  <!-- 后台返回的数据格式为{code:200,msg:'success',data:[...],coount:100} -->
  <!-- 若显示序号行直接传入 index-column:true 即可，会自动在最前面的列加入序号行 -->
  <!-- 若开启多选功能需要传入checked-column:true即可，会自动在最前面加入多选列 -->
  <!-- 若开启自定义排序功能需要传入custom-sort:true即可，会自动在参数中加入sort属性，排序改变时sort值格式：字段名称 +' '+asc/desc,如：id asc -->
  <!-- 传入列数据使用<template slot="columns"> 在这里写入列数据</template> -->
  <div class="xh-page-table" ref="container" :class="{ 'custom-table': dark }">
    <el-table :data="tableData" :height="isPage ? 'calc(100% - 48px)' : '100%'" ref="mytable" class="mytable"
      :stripe="stripe" :border="border" :highlight-current-row="highlightCurrentRow" :size="size" :fit="fit"
      :showHeader="showHeader" :emptyText="emptyText" :default-expand-all="defaultExpandAll" :default-sort="defaultSort"
      :empty-text="emptyText" :select-on-indeterminate="selectOnIndeterminate" :indent="indent" v-loading="loading"
      :element-loading-background="loadingBackground" :span-method="spanMethod" :tree-props="treeProps" :row-key="rowKey"
      :row-class-name="rowClassName" :row-style="rowStyle" :show-summary="showsummary" 
    >
      <el-table-column type="selection" width="40" align="center" v-if="checkedColumn"></el-table-column>
      <el-table-column label="序号" align="center" width="60" :fixed="indexColumnFixed" v-if="indexColumn">
        <template slot-scope="scope">
          <span>{{ scope.$index + (pageIndex - 1) * pageSize + 1 }}</span>
        </template>
      </el-table-column>
      <slot></slot>
      <slot name="columns"></slot>
    </el-table>
    <el-pagination v-if="isPage" ref="mypage" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :page-sizes="[10, 25, 50, 100]" :page-size="pageSize" :current-page="pageIndex"
      layout="total, sizes, prev, pager, next, jumper" :total="total" :popper-class="pagePopperClass"></el-pagination>
  </div>
</template>
<script>
import elementResizeDetectorMaker from "element-resize-detector";
export default {
  props: {
    dark: {
      //是否是暗夜模式，暗夜模式下，表格整体样式变为深色系
      type: Boolean,
      default: false,
    },
    //查询数据的url
    url: String,
    //是否显示合计行
    showsummary: {
      type: Boolean,
      default: false,
    },
    //是否使用baseUrl
    useBaseUrl: {
      type: Boolean,
      default: true,
    },
    //查询数据的方法
    method: {
      type: String,
      default: "GET",
    },
    //查询参数
    params: Object,
    //是否开启自定义排序
    customSort: {
      type: Boolean,
      default: true,
    },
    //是否显示序号列
    indexColumn: {
      type: Boolean,
      default: false,
    },
    indexColumnFixed: {
      type: Boolean,
      default: false,
    },
    //是否开启多选框列
    checkedColumn: {
      type: Boolean,
      default: false,
    },
    //是否首次自动加载数据
    autoLoad: {
      type: Boolean,
      default: true,
    },
    //以下为eltable中的属性，这里接收后重新赋给eltable
    stripe: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: true,
    },
    rowClassName: {
      type: Function,
      default: function () {},
    },
    rowStyle: {
      type: Function,
      default: function () {},
    },
    highlightCurrentRow: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "small",
    },
    fit: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    emptyText: {
      type: String,
      default: "暂无数据",
    },
    defaultExpandAll: {
      type: Boolean,
      default: false,
    },
    defaultSort: {
      type: Object,
    },
    tooltipEffect: {
      type: String,
      default: "dark",
    },
    selectOnIndeterminate: {
      type: Boolean,
      default: true,
    },
    indent: {
      type: Number,
      default: 16,
    },
    isPage: {
      type: Boolean,
      default: true,
    },
    spanMethod:{
      type:Function,
      default: function () {
      }
    },
    isUseSpanMethod:{
      type:Boolean,
      default:false
    },
    treeProps:{
      type:Object,
      default:function () {
      }
    },
    rowKey:{
      type:String,
      default:""
    }
  },
  data() {
    return {
      pagePopperClass: "",
      loadingBackground: "#rgba(255,255,255,0.5)",
      showCheckColumn: false,
      tableData: [],
      myParams: this.params,
      total: 0,
      pageSize: 25,
      pageIndex: 1,
      loading: false,
      tableHeight: null,
    };
  },
  methods: {
    setCurrentRow(row) {
      this.$refs.mytable.setCurrentRow(row);
    },
    toggleRowSelection(row, selected) {
      this.$refs.mytable.toggleRowSelection(row, selected);
    },
    clearSelection() {
      this.$refs.mytable.clearSelection();
    },
    headerStyle({ row, rowIndex }) {
      return "tableHead";
    },
    //根据父组件是否传入事件方法判断是否监听eltable中对应的事件
    bindEvent() {
      let that = this;
      if (that.$listeners["select"]) {
        that.$refs.mytable.$on("select", function (selection, row) {
          that.$emit("select", selection, row);
        });
      }

      if (that.$listeners["select-all"]) {
        that.$refs.mytable.$on("select-all", function (selection) {
          that.$emit("select-all", selection);
        });
      }

      if (that.$listeners["selection-change"]) {
        that.$refs.mytable.$on("selection-change", function (selection) {
          that.$emit("selection-change", selection);
        });
      }

      if (that.$listeners["cell-mouse-enter"]) {
        that.$refs.mytable.$on(
          "cell-mouse-enter",
          function (row, column, cell, event) {
            that.$emit("cell-mouse-enter", row, column, cell, event);
          }
        );
      }
      if (that.$listeners["cell-mouse-leave"]) {
        that.$refs.mytable.$on(
          "cell-mouse-leave",
          function (row, column, cell, event) {
            that.$emit("cell-mouse-leave", row, column, cell, event);
          }
        );
      }
      if (that.$listeners["cell-click"]) {
        that.$refs.mytable.$on(
          "cell-click",
          function (row, column, cell, event) {
            that.$emit("cell-click", row, column, cell, event);
          }
        );
      }
      if (that.$listeners["cell-dblclick"]) {
        that.$refs.mytable.$on(
          "cell-dblclick",
          function (row, column, cell, event) {
            that.$emit("cell-dblclick", row, column, cell, event);
          }
        );
      }
      if (that.$listeners["row-click"]) {
        that.$refs.mytable.$on("row-click", function (row, column, event) {
          that.$emit("row-click", row, column, event);
        });
      }
      if (that.$listeners["row-contextmenu"]) {
        that.$refs.mytable.$on(
          "row-contextmenu",
          function (row, column, event) {
            that.$emit("row-contextmenu", row, column, event);
          }
        );
      }
      if (that.$listeners["row-dblclick"]) {
        that.$refs.mytable.$on("row-dblclick", function (row, column, event) {
          that.$emit("row-dblclick", row, column, event);
        });
      }
      if (that.$listeners["header-click"]) {
        that.$refs.mytable.$on("header-click", function (column, event) {
          that.$emit("header-click", column, event);
        });
      }
      if (that.$listeners["header-contextmenu"]) {
        that.$refs.mytable.$on("header-contextmenu", function (column, event) {
          that.$emit("header-contextmenu", column, event);
        });
      }
      if (this.customSort) {
        that.$refs.mytable.$on("sort-change", function (obj) {
          that.sortChange(obj);
        });
      }
      if (that.$listeners["filter-change"]) {
        that.$refs.mytable.$on("filter-change", function (obj) {
          that.$emit("filter-change", obj);
        });
      }
      if (that.$listeners["current-change"]) {
        that.$refs.mytable.$on(
          "current-change",
          function (currentRow, oldCurrentRow) {
            that.$emit("current-change", currentRow, oldCurrentRow);
          }
        );
      }
      if (that.$listeners["header-dragend"]) {
        that.$refs.mytable.$on(
          "header-dragend",
          function (newWidth, oldWidth, column, event) {
            that.$emit("header-dragend", newWidth, oldWidth, column, event);
          }
        );
      }
      if (that.$listeners["expand-change"]) {
        that.$refs.mytable.$on("expand-change", function (row, obj) {
          that.$emit("expand-change", row, obj);
        });
      }
    },
    loadData() {
      let that = this;
      if (!that.myParams) {
        that.myParams = {};
      }
      if (this.isPage) {
        that.myParams.pageSize = that.pageSize;
        that.myParams.pageIndex = that.pageIndex;
      }
      that.loading = true;
      that.$api.axios(
        that.method,
        that.url,
        that.myParams,
        function (res) {
          
          if (res.code == 200) {
            if (that.isPage) {
              that.total = res.count;
            }
            that.tableData = (res.data?res.data:[]);
            console.log(that.tableData)
          }
          if (that.isUseSpanMethod) {
            that.$emit("getSpanData", res.data?res.data:[]);
          }
          that.$emit("loaded", res);
          that.loading = false;
        },
        function () {
          that.$message.error("获取数据失败");
          that.loading = false;
        },
        that.useBaseUrl
      );
    },
    reload() {
      this.pageIndex = 1;
      this.loadData();
    },
    //每页条数变化事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadData();
    },
    //当前页变化事件
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.loadData();
    },
    sortChange(val) {
      let that = this;
      if (!that.myParams) {
        that.myParams = {};
      }
      let sort = "";
      if (val.prop && val.order) {
        sort = val.prop + " " + (val.order == "ascending" ? "asc" : "desc");
      }
      that.myParams.sort = sort;
      that.loadData();
    },
    resize() {
      let that = this;
      that.$nextTick(() => {
        that.tableHeight = that.$refs.container.clientHeight - 55;
      });
    },
  },
  created() {},
  mounted() {
    let that = this;
    that.resizeMaker = elementResizeDetectorMaker();

    this.$nextTick(function () {
      //console.log(that.$children);
      that.bindEvent();
      if (that.autoLoad) {
        that.loadData();
      }
      that.resize();
      // that.resizeMaker.listenTo(
      //   that.$refs.container,
      //   that.$util.debounce(that.resize)
      // );//这里增加防抖动，防止动画效果导致容器变化频率过快引起的卡顿
    });
  },
  updated(){
      this.$nextTick(() => {
          this.$refs['mytable'].doLayout()   
          // table是在表格中ref=‘table’
          // doLayout	对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
      })
  },
  watch: {
    params:{
      immediate:true,
      handler:function(newValue){
        this.myParams=this.params;
      }
    },
    dark: {
      immediate: true,
      handler: function (newValue) {
        if (this.dark) {
          this.pagePopperClass = "black-select-popper";
          this.loadingBackground = "rgba(0,0,0,0.5)";
        } else {
          this.pagePopperClass = "";
          this.loadingBackground = "rgba(255,255,255,0.5)";
        }
      },
    },
  },
};
</script>
<style lang="less" scoped>
.xh-page-table {
  height: 100%;
  width: 100%;
}
//修复当使用固定列时，横向滚动条被盖住，鼠标无法选中的问题
/deep/.el-table__body-wrapper {
  z-index: 2;
}
/deep/.el-table__header-wrapper table thead tr th {
  background: #f5f7fa;
  color: #444;
  border-bottom: 1px solid #e1e4ed;
}

/deep/.el-table__fixed-header-wrapper table thead tr th {
  background: #f5f7fa;
  color: #444;
  border-bottom: 1px solid #e1e4ed;
}

/deep/.el-table__header-wrapper table thead tr th .cell {
  white-space: nowrap;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.el-pagination {
  margin-top: 15px;
}
</style>